import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

import { TypeaheadItem } from '../../../_models/typeahead/typeahead.item';
import { AdminService } from '../../../_services/admin/admin.service';

@Component({
  selector: 'app-admin-typeahead-item-search',
  templateUrl: './admin-typeahead-item-search.component.html',
  styleUrls: ['./admin-typeahead-item-search.component.scss']
})
export class AdminTypeaheadItemSearchComponent implements OnInit {
  @Input() label: string;
  @Input() centerLabel: boolean = false;
  @Input() start: string;
  @Input() wholesaler: number;
  @Output() selected: EventEmitter<TypeaheadItem> = new EventEmitter<TypeaheadItem>();
  @Output() blur: EventEmitter<string> = new EventEmitter<string>();
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() labelCols: number = 2;
  @Input() dividerKind: number;
  @Input() focusInput: EventEmitter<boolean>;
  @Input() emptyAfterSelected: boolean;
  @Input() searchInDescription = true;
  @Input() dropup: boolean = false;
  uniqueId = Math.random().toString(36).substring(2);

  constructor(
    public adminService: AdminService
  ) { }

  ngOnInit() {
    if (!this.focusInput) { this.focusInput = new EventEmitter<boolean>(); }
    if (this.labelCols!==0 && !this.labelCols) { this.labelCols = 2; }
  }

  typeaheadOnSelect(match: TypeaheadMatch) {
    this.selected.emit(match.item);
    if (this.emptyAfterSelected) {
      setTimeout(() => this.start = '', 10);
    }
  }

  onBlur(event: FocusEvent) {
    setTimeout(() => this.blur.emit(this.start), 500);
  }

}
